<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <defs>
      <path id="a" d="M0 0h81.914v100H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <path
          :fill="iconColor"
          d="M61.124 71.535h-2.537l-1.755-3.012h-.566v3.012h-2.237v-8.277h2.712c2.25 0 3.375.814 3.375 2.445 0 .96-.469 1.701-1.404 2.226l2.412 3.606zm-16.409 0l2.701-8.312h2.983l2.735 8.312h-2.446l-.408-1.552h-2.689l-.419 1.552h-2.457zm-.752-5.18v1.794h-2.481v1.563h2.678v1.823h-4.914v-8.277h4.914v1.794h-2.678v1.302h2.481zm-6.042 3.373v1.807h-5.424v-8.277h2.236v6.47h3.188zm-9.139.091c.366 0 .721-.05 1.065-.152.343-.103.689-.225 1.036-.368v1.89c-.691.306-1.472.46-2.344.46-1.249 0-2.207-.363-2.873-1.088-.667-.724-1-1.772-1-3.142 0-.857.161-1.61.484-2.259a3.472 3.472 0 0 1 1.393-1.498c.606-.349 1.318-.523 2.137-.523.895 0 1.75.194 2.565.583l-.685 1.76a7.923 7.923 0 0 0-.917-.362 3.21 3.21 0 0 0-.985-.147c-.533 0-.948.217-1.246.654-.298.435-.447 1.037-.447 1.804 0 1.592.606 2.388 1.817 2.388zM21.189 67v-3.742h1.993v8.277h-2.933l-3.023-5.832h-.051c.072.917.108 1.617.108 2.101v3.731h-1.982v-8.277h2.922l3.011 5.752h.035a33.29 33.29 0 0 1-.08-2.01zm50.018 26.481H16.07c-2.286 0-4.148-1.849-4.148-4.124v-4.77h51.4c2.384 0 4.317-1.918 4.317-4.288V54.29c0-2.37-1.933-4.289-4.317-4.289h-51.4V10.643c0-2.269 1.862-4.119 4.148-4.119l37.957-.039V20.43c0 4.073 3.325 7.38 7.426 7.38l13.743-.039.156 61.586c0 2.275-1.858 4.124-4.145 4.124zM7.388 70.782c-.605-.577-.909-1.408-.909-2.49v-5.034h2.249v4.857c0 .585.109 1.01.328 1.274.219.264.542.396.968.396.457 0 .788-.13.994-.393.206-.262.308-.692.308-1.289v-4.845h2.237v4.982c0 1.083-.307 1.922-.92 2.517-.614.594-1.498.891-2.653.891-1.129 0-1.996-.289-2.602-.866zM56.48 0H16.07C10.166 0 5.361 4.78 5.361 10.643V50H4.315C1.932 50 0 51.92 0 54.288V80.3c0 2.37 1.932 4.287 4.315 4.287h1.046v4.77c0 5.87 4.805 10.642 10.707 10.643h55.141c5.899 0 10.705-4.774 10.705-10.643V25.19L56.48 0z"
        />
      </g>
      <path
        :fill="iconColor"
        d="M56.707 64.95h-.441v1.892h.419c.781 0 1.171-.346 1.171-1.037 0-.57-.382-.855-1.149-.855M49.46 66.79a49.012 49.012 0 0 1-.304-1.172 18.84 18.84 0 0 1-.234-1.03c-.034.192-.102.51-.201.951-.1.441-.323 1.312-.665 2.61h1.76l-.356-1.359zM33 15c-6.593 0-12 5.396-12 12 0 6.607 5.394 12 12 12 6.577 0 12-5.372 12-12 0-3.192-1.284-6.188-3.549-8.452C39.187 16.284 36.192 15 33 15m0 21.141A9.13 9.13 0 0 1 23.859 27c0-1.969.619-3.839 1.758-5.386l12.769 12.755A8.963 8.963 0 0 1 33 36.141m7.369-3.755L27.614 19.617A9.043 9.043 0 0 1 33 17.859 9.129 9.129 0 0 1 42.141 27a8.97 8.97 0 0 1-1.772 5.386"
      />
      <path
        :stroke="iconColor"
        stroke-width="3"
        d="M33 15c-6.593 0-12 5.396-12 12 0 6.607 5.394 12 12 12 6.577 0 12-5.372 12-12 0-3.192-1.284-6.188-3.549-8.452C39.187 16.284 36.192 15 33 15zm0 21.141A9.13 9.13 0 0 1 23.859 27c0-1.969.619-3.839 1.758-5.386l12.769 12.755A8.963 8.963 0 0 1 33 36.141zm7.369-3.755L27.614 19.617A9.043 9.043 0 0 1 33 17.859 9.129 9.129 0 0 1 42.141 27a8.97 8.97 0 0 1-1.772 5.386z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-unclear',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      },
      stroke: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
